"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = exports.copyLinkedGif = exports.option = exports.timeToSeconds = exports.generateStartValue = exports.validateEmail = exports.copyHTMLToClipboard = exports.copyToClipboard = void 0;
const copyToClipboard = (text = '') => __awaiter(void 0, void 0, void 0, function* () {
    if ('clipboard' in navigator) {
        return yield navigator.clipboard.writeText(text);
    }
    else {
        return new Promise(res => {
            document.execCommand('copy', true, text);
            res({});
        });
    }
});
exports.copyToClipboard = copyToClipboard;
const copyHTMLToClipboard = (html) => __awaiter(void 0, void 0, void 0, function* () {
    const blob = new Blob([html], { type: 'text/html' });
    //@ts-ignore
    const data = [new ClipboardItem({ 'text/html': blob })];
    return navigator.clipboard.write(data);
});
exports.copyHTMLToClipboard = copyHTMLToClipboard;
const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};
exports.validateEmail = validateEmail;
const generateStartValue = (time) => {
    const value = Math.floor(time);
    const data = formatTime(value).split(':');
    if (data.length < 3)
        data.unshift('00');
    return data.join(':');
};
exports.generateStartValue = generateStartValue;
const formatTime = (seconds, showHours = false) => {
    const format = (val) => `0${Math.floor(val)}`.slice(-2);
    const hours = seconds / 3600;
    const minutes = (seconds % 3600) / 60;
    const secs = seconds % 60;
    const h = hours >= 1 || showHours ? [hours] : [];
    return [...h, minutes, secs].map(format).join(':');
};
const timeToSeconds = (time) => {
    if (!time)
        return 0;
    return time
        .split(':')
        .reverse()
        .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
};
exports.timeToSeconds = timeToSeconds;
const option = (value, label) => ({ value, label });
exports.option = option;
const copyLinkedGif = ({ playbook, copyLinkPath, uid, isQuickGuidde, trackLinkName, trackLinkId, trackLink }) => {
    const { gifUrl, screenshotUrl } = playbook;
    const urlParams = new URLSearchParams();
    if (trackLinkName) {
        urlParams.append('track_link_name', trackLinkName);
    }
    if (trackLinkId) {
        urlParams.append('track_link_id', trackLinkId);
    }
    urlParams.append('origin', uid);
    const link = `${window.location.origin}${copyLinkPath}?${urlParams.toString()}`;
    const width = isQuickGuidde ? '700px' : '250px';
    const height = isQuickGuidde ? 'auto' : '175px';
    const imageHtml = `
         <table width:100%">
              <style>
                 a {
                     font-size: 16px;
                     text-decoration: underline;
                 }
                 img {
                     object-fit: contain;
                     border-radius: 2px;
                 }
                 tr {
                    background-color: white;
                 }
             </style>
             <tr>
                 <td>
                     <a href=${link}>${playbook.title}</a>
                 </td>
             </tr>
             <tr>
                 <td>
                 <a href=${link} >
                     <img width=${width} height=${height}  alt="" src=${gifUrl || screenshotUrl} />
                 </a>
                 </td>
             </tr>
             ${trackLink
        ? `<tr><td><a href=${trackLink}>Track link</a></td></tr>`
        : ''}
         </table>
         `;
    return (0, exports.copyHTMLToClipboard)(imageHtml);
};
exports.copyLinkedGif = copyLinkedGif;
const capitalize = (str) => {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
};
exports.capitalize = capitalize;
//# sourceMappingURL=utils.js.map